import {Box, Flex, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {StarRating} from '../../components/StarRating'
import {SubsectionTitle} from '../../components/Subsection'
import IconTooltip from '../../components/IconTooltip'

export const CustomerRatingSection = ({score, topReason}) => {
  const {t} = useTranslation('customers')

  return (
    <Box bg="neutral.200" width="fit-content" data-testid="customer-rating">
      <SubsectionTitle title={t('CustomerRatings.title')} />
      <Flex
        width="fit-content"
        aria-label={t('CustomerRatings.score', {
          score,
        })}
      >
        <StarRating score={score} size="16px" />
        <IconTooltip iconColor="black">
          <Text>{t(`CustomerRatings.Reasons.${topReason}`)}</Text>
        </IconTooltip>
      </Flex>
    </Box>
  )
}

CustomerRatingSection.propTypes = {
  score: PropTypes.number.isRequired,
  topReason: PropTypes.string.isRequired,
}

export default CustomerRatingSection
